import React from 'react';

import { Home } from './pages/home';
import './Application.css';

export function Application() {
  return <Home />;
}
